import { get, map, filter, forEach } from "lodash";

import { fetchGet } from "../api/fetch";

import {
  GET_POLICIES,
  GET_PUBLISHERS,
  GET_ACCEPTANCES,
  SET_STATUS,
} from "../constants/actionTypes";
import { API_DATASTORE } from "../constants/api";
import { ok, warning, denied } from "../constants/common";

import { isUserRoleConcerned, remainingPolicyTime } from "../utils/policies";

/** PUBLISHERS */
export const getPublishers = () => {
  return async (dispatch, getState) => {
    try {
      const res = await fetchGet("ds/sys/publishers", API_DATASTORE);
      dispatch({
        type: GET_PUBLISHERS,
        payload: map(get(res, ["data"]), (item) => get(item, ["value"])),
      });
    } catch (e) {
      console.log(e);
    }
  };
};

/** POLICIES */
export const getPolicies = () => {
  return async (dispatch, getState) => {
    try {
      const res = await fetchGet("ds/sys/policies", API_DATASTORE);

      let policies = map(get(res, ["data"]), (item) => get(item, ["value"]));

      const archivedPolicies = filter(
        policies,
        (p) => get(p, ["state"]) === "archived"
      );

      // Filter policies: published && concern user role
      policies = filter(
        policies,
        (p) =>
          get(p, ["state"]) === "published" &&
          isUserRoleConcerned(
            p,
            get(getState(), ["policies", "publishers"]),
            get(getState(), ["user", "role", "roles"])
          )
      );

      dispatch({
        type: GET_POLICIES,
        policies,
        archivedPolicies,
      });
    } catch (e) {
      console.log(e);
    }
  };
};

/** ACCEPTANCES */
export const getAcceptances = () => {
  return async (dispatch, getState) => {
    try {
      const res = await fetchGet("ds/usr/acceptances", API_DATASTORE);
      dispatch({
        type: GET_ACCEPTANCES,
        payload: map(get(res, ["data"]), (item) => get(item, ["value"])),
      });
    } catch (e) {
      console.log(e);
    }
  };
};

/** POLICIES STATUS */
export const processPoliciesStatus = () => {
  return async (dispatch, getState) => {
    let access = {
      ok: false,
      warning: false,
      denied: false,
    };
    let status = {
      ok: false,
      warning: false,
      denied: false,
    };
    forEach(
      filter(
        get(getState(), ["policies", "policies"]),
        (p) => get(p, ["compliance", "compliance"]) === "required"
      ),
      (p) => {
        const accepted = get(
          filter(
            get(getState(), ["policies", "acceptances"]),
            (a) =>
              get(p, ["id"]) === get(a, ["policy", "id"]) &&
              get(p, ["published"]) === get(a, ["policy", "published"])
          ),
          [0]
        );

        if (get(accepted, ["accepted"]) === true) {
          access.ok = true;
          status.ok = true;
        } else if (get(accepted, ["accepted"]) === false) {
          access.denied = true;
          status.denied = true;
        } else {
          status.warning = true;
          const remainingTime = remainingPolicyTime(p);
          if (remainingTime === 0) {
            access.denied = true;
          } else {
            access.warning = true;
          }
        }
      }
    );

    dispatch({
      type: SET_STATUS,
      payload: {
        access: access.denied ? denied : access.warning ? warning : ok,
        status: status.denied ? denied : status.warning ? warning : ok,
      },
    });
  };
};
